<div class="check-sheet-wrapper p-20">
    @if(isAuthorizedToView) {
    <mat-card>
        <mat-card-header>
            <mat-card-title>
                Doctor's Clerking Sheet - Patient ID: {{getPatientHumanId()}}
            </mat-card-title>
            <mat-card-subtitle>
                Verify and edit the records entered for this encounter.
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content class="mt-18">
            <mat-expansion-panel (opened)="onPatientInfoPanelOpened()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Patient Information
                    </mat-panel-title>

                </mat-expansion-panel-header>
                <div>
                    @if(resolvedData && resolvedData.name && resolvedData.name.length > 0) {
                    <div class="g-just-flex justify-content-start flex-wrap gap-15 align-items-center">
                        <div class="rounded-image">
                            <img style="border-radius: 50%;" width="100" height="100"
                                src="https://www.dummyimg.in/placeholder" alt="" srcset="" loading="lazy">
                        </div>

                        <div style="flex-direction: column; align-items: start;" class="short-details
                                        g-just-flex flex-column gap-12
                                        ">
                            <div class="top  g-just-flex gap-12 justify-content-start">
                                <span style="text-align: center;">{{resolvedData?.name?.[0]?.family |
                                    titlecase}}
                                    {{resolvedData?.name?.[0]?.given?.[0] |
                                    titlecase}}</span><span></span><span></span>
                            </div>
                            <div class="bottom  g-just-flex gap-12 justify-content-start" style="font-size: 16px;">
                                <div class="g-just-flex gap-8">


                                    <mat-icon style="font-size: 16px; width: 16px; height: 16px;

                                                        ">person</mat-icon>

                                    <span>{{resolvedData?.gender | titlecase}}</span>

                                </div> |
                                <div class="g-just-flex gap-8">


                                    <mat-icon style="font-size: 16px; width: 16px; height: 16px;

                                                        ">cake</mat-icon>

                                    <span>{{resolvedData?.birthDate | age}}</span>

                                </div> |
                                <div class="g-just-flex gap-8">


                                    <mat-icon style="font-size: 16px; width: 16px; height: 16px;

                                                        ">location_on</mat-icon>

                                    <span>
                                        {{resolvedData?.address?.[0]?.city}},
                                        {{resolvedData?.address?.[0]?.state}},
                                        {{resolvedData?.address?.[0]?.country}}</span>

                                </div>



                                <span></span>
                            </div>
                            <div class="bottom-last  g-just-flex gap-12 justify-content-start" style="font-size: 16px;">
                                <div class="g-just-flex gap-8">


                                    <mat-icon style="font-size: 16px; width: 16px; height: 16px;

                                                        ">phone</mat-icon>

                                    <span> <a style="text-decoration: none !important;"
                                            href="tel:{{resolvedData?.telecom?.[0]?.value}}">
                                            {{resolvedData?.telecom?.[0]?.value}}
                                        </a> </span>

                                </div>




                                <span></span>
                            </div>
                        </div>
                    </div>
                    <div class="g-just-flex gap-20 mt-30 justify-content-start flex-wrap" style="align-items: unset;">

                        <mat-card style="width: max-content; max-width: max-content;">
                            <div class="bottom  g-just-flex gap-12 justify-content-start p-15" style="
                                flex-direction: column;
                                align-items: flex-start;
                                font-size: 16px;">
                                <div class="info-group-title high-criticality mb-20" style="padding: 0rem 0.5rem;
                                    border-radius: 2px;
                                    ">
                                    Allergies
                                </div>
                                <div class="red-pill-wrapper gap-20 g-just-flex flex-wrap justify-content-start">

                                    @if(patientInfoActivated){
                                    @if((allergiesLoading$ | async) === true && (!allergyRows || allergyRows.length ===
                                    0)){
                                    <div class="subtitle-text-color-2 mb-10">Loading…</div>
                                    }
                                    }

                                    @if(allergyRows && allergyRows.length > 0){
                                    @for(allergy of allergyRows; track allergy.id){
                                    <div class="red-pills g-just-flex gap-8">
                                        <div class="position-absolute severity"
                                            [class.high-criticality]="allergy.criticality === 'high'"
                                            [class.low-criticality]="allergy.criticality !== 'high'">

                                            <mat-icon class="me-8">report_problem</mat-icon>
                                        </div>
                                        <div class="g-just-flex gap-8" style="flex-direction: row;">
                                            <mat-icon>medication</mat-icon>
                                            <span class="allergy">{{allergy.substance}}</span>
                                        </div>
                                    </div>
                                    }
                                    } @else {
                                    @if(patientInfoActivated && (allergiesLoading$ | async) === false){
                                    <div class="subtitle-text-color-2">No known allergies.</div>
                                    }
                                    }
                                </div>
                                <span></span>
                            </div>

                        </mat-card>
                    </div>
                    }
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel (opened)="onVitalsPanelOpened()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Patient Vitals
                    </mat-panel-title>

                </mat-expansion-panel-header>

                <!-- Vitals table and actions -->
                <div class="vitals-table-wrapper">
                    @if(vitalsActivated){
                    @if((vitalsLoading$ | async) === true && (!vitalRows || vitalRows.length === 0)){
                    <div class="subtitle-text-color-2 mb-10">Loading…</div>
                    }
                    }
                    @if(vitalsActivated && vitalRows.length > 0){

                    <!-- {{ vitalTableDataSource.data | json }} -->

                    <table mat-table [dataSource]="vitalTableDataSource" class="mat-elevation-z1 w-100">

                        <ng-container matColumnDef="display">
                            <th mat-header-cell *matHeaderCellDef> Vital </th>
                            <td mat-cell *matCellDef="let v">{{ v[0].display }}</td>
                        </ng-container>

                        <ng-container matColumnDef="value">
                            <th mat-header-cell *matHeaderCellDef> Value </th>
                            <td mat-cell *matCellDef="let v" style="width: 280px !important;
    max-width: unset !important;
    white-space: normal;
    padding: 6px 0px;">
                                <app-observation-value-display [observation]="v[0].original"></app-observation-value-display>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let v">
                                <div [appChips]="v[0].status" [fontSize]="'14px'"></div>
                                <!-- {{ v.status | titlecase }} -->
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef> Action </th>
                            <td mat-cell *matCellDef="let v">
                                @if(canEditEncounter){
                                <button mat-button color="primary" [matMenuTriggerFor]="menu">Change Status</button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="changeVitalStatus(v[0], 'entered-in-error')">
                                        Entered in error
                                    </button>
                                    <button mat-menu-item (click)="changeVitalStatus(v[0], 'cancelled')">
                                        Cancelled
                                    </button>
                                </mat-menu>
                                }
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="history">
                            <th mat-header-cell *matHeaderCellDef> History </th>
                            <td mat-cell *matCellDef="let v">
                                <button mat-icon-button (click)="showVitalHistory(v); $event.stopPropagation();">
                                    <mat-icon>history</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>

                    <div class="vitals-actions g-just-flex gap-12 mt-12">
                        @if(canEditEncounter && !isPatientUser){
                        <button mat-stroked-button color="primary" (click)="addMoreVitals()">Add More</button>
                        }
                    </div>
                    } @else {
                    <div class="subtitle-text-color-2 mb-10">
                        @if(!vitalsActivated){
                        Open this section to load vitals.
                        } @else {
                        No vitals available for this encounter.
                        }
                    </div>
                    @if(canEditEncounter && !isPatientUser){
                    <button mat-stroked-button color="primary" (click)="addMoreVitals()">Add Vitals</button>
                    }
                    }

                    <!-- Add Vitals Form -->
                    <!-- <app-add-vitals *ngIf="showAddVitals" [initialValues]="vitalsPrefill"></app-add-vitals> -->
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="onPhysicalExamPanelOpened()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Physical Examination
                    </mat-panel-title>

                </mat-expansion-panel-header>

                <!-- Added reusable exam table -->
                <div class="exam-table-wrapper mb-16">
                    @if(physicalExamActivated){
                    @if((physicalExamLoading$ | async) === true && (!examRows || examRows.length === 0)){
                    <div class="subtitle-text-color-2 mb-10">Loading…</div>
                    }
                    }
                    @if(physicalExamActivated && examRows.length > 0){
                    <table mat-table [dataSource]="examTableDataSource" class="mat-elevation-z1 w-100">
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef> Exam </th>
                            <td mat-cell *matCellDef="let r" class="exam-name-cell">{{ r.name }}</td>
                        </ng-container>

                        <ng-container matColumnDef="value">
                            <th mat-header-cell *matHeaderCellDef> Value </th>
                            <td mat-cell *matCellDef="let r" style="max-width: 300px;">
                                <div style="white-space: wrap; max-width: 400px;">
                                    {{ r.value }}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let r">
                                <div [appChips]="r.status" [fontSize]="'14px'"></div>
                                <!-- {{ r.status | titlecase }} -->

                            </td>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef> Action </th>
                            <td mat-cell *matCellDef="let r">
                                @if(canEditEncounter){
                                <button mat-button color="primary" [matMenuTriggerFor]="examMenu">Change Status</button>
                                <mat-menu #examMenu="matMenu">
                                    <button mat-menu-item (click)="changeExamStatus(r, 'entered-in-error')">Entered in
                                        error</button>
                                    <button mat-menu-item (click)="changeExamStatus(r, 'cancelled')">Cancelled</button>
                                </mat-menu>
                                }
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="examDisplayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: examDisplayedColumns;"></tr>
                    </table>
                    <!--ADD more physical exam-->
                    <div class="exam-actions g-just-flex gap-12 mt-12 ">
                        <button mat-stroked-button color="primary" (click)="addMoreExam()"
                            [disabled]="!canEditEncounter">Add More Exam
                            Findings</button>
                    </div>
                    } @else {

                    <div class="subtitle-text-color-2 mb-10">
                        @if(!physicalExamActivated){
                        Open this section to load physical exam findings.
                        } @else {
                        No examination findings for this encounter.
                        }
                    </div>
                    <div class="exam-actions g-just-flex gap-12 mt-12 " style="justify-content: flex-end;">
                        @if(canEditEncounter && !isPatientUser){
                        <button mat-stroked-button color="primary" (click)="addMoreExam()">Add More Exam Findings</button>
                        }
                    </div>
                    }
                </div>

                <!-- <app-obs-res [initialExam]="examPrefill"></app-obs-res> -->
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="onPatientSymptomsPanelOpened()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Patient Presented Symptoms & Social History
                    </mat-panel-title>

                </mat-expansion-panel-header>

                <!-- Complaints table -->
                <div class="complaints-table-wrapper mb-16">
                    @if(patientSymptomsActivated){
                    @if((patientSymptomsLoading$ | async) === true && (!dataForPatSymp || dataForPatSymp.length === 0)){
                    <div class="subtitle-text-color-2 mb-10">Loading…</div>
                    }
                    }
                    @if(dataForPatSymp && dataForPatSymp.length > 0){
                    <div class="px-20 pb-20">
                    <app-pat-symp [hideSubmitAction]="true" [initialData]="dataForPatSymp" [editMode]="canEditEncounter"></app-pat-symp>
                    </div>
                    } @else {
                    <div class="subtitle-text-color-2 mb-10">
                        @if(!patientSymptomsActivated){
                        Open this section to load symptoms.
                        } @else {
                        No data for this encounter.
                        }
                    </div>
                    }
                </div>
                <!--actions-->
                <mat-action-row>
                    @if(canEditEncounter && !isPatientUser){
                    <button mat-button (click)="addPatientReportedSymptoms()">
                        <mat-icon>add</mat-icon>
                        Add Patient Reported Symptoms</button>
                    }
                </mat-action-row>
                <!-- <app-pat-symp [initialSymptoms]="symptomsPrefill"></app-pat-symp> -->
                </mat-expansion-panel>

                @if(canViewLabSection){
            <mat-expansion-panel (opened)="onLabTestsPanelOpened()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Lab Tests
                    </mat-panel-title>

                </mat-expansion-panel-header>

                <div class="complaints-table-wrapper mb-16">
                    @if(labTestsActivated){
                    @if((labTestsLoading$ | async) === true && (!labRequestRows || labRequestRows.length === 0)){
                    <div class="subtitle-text-color-2 mb-10">Loading…</div>
                    }
                    }

                    @if(labTestsActivated && labRequestRows && labRequestRows.length > 0){
                    <table mat-table [dataSource]="labRequestTableDataSource"
                        class="mat-elevation-z1 w-100 lab-tests-table">

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let r">
                                <div [appChips]="r.status" [fontSize]="'14px'"></div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="code">
                            <th mat-header-cell *matHeaderCellDef> Service / Test </th>
                            <td mat-cell *matCellDef="let r" class="lab-code-cell">{{ r.code }}</td>
                        </ng-container>

                        <ng-container matColumnDef="request">
                            <th mat-header-cell *matHeaderCellDef> Requested </th>
                            <td mat-cell *matCellDef="let r">
                                @if(r.authoredOn){
                                <div class="lab-date-top">{{ r.authoredOn | date:'mediumDate' }}</div>
                                <div class="lab-date-bottom">{{ r.authoredOn | date:'shortTime' }}</div>
                                } @else {
                                <div class="subtitle-text-color-2">—</div>
                                }
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef> Report </th>
                            <td mat-cell *matCellDef="let r">
                                <div class="lab-report-action">
                                    <button mat-button class="lab-report-btn"
                                        (click)="viewFinalDiagnosticReportForLabRequest(r)" [disabled]="!r.id">
                                        <mat-icon>description</mat-icon>
                                        Report
                                    </button>

                                    <span [appEmphasis]="r.reportAvailabilityStatus" [showBorder]="false"
                                        [fontSize]="'12px'" [opacity]="'0.85'">
                                        {{ labReportAvailabilityLabel(r.reportAvailabilityStatus) }}
                                    </span>
                                </div>
                            </td>
                        </ng-container>
                        <!--actions container-->

                        <ng-container matColumnDef="revokeAction">
                            <th mat-header-cell *matHeaderCellDef> Action </th>
                            <td mat-cell *matCellDef="let r">
                                @if(canEditEncounter && !isPatientUser){
                                <button mat-icon-button [matMenuTriggerFor]="labRowMenu"
                                    (click)="$event.stopPropagation()" [disabled]="!canEditEncounter || !r.id"
                                    aria-label="More actions">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #labRowMenu="matMenu">
                                    <button mat-menu-item (click)="revokeServiceRequest(r); $event.stopPropagation()"
                                        [disabled]="!canEditEncounter || !canRevokeServiceRequest(r)">
                                        <mat-icon>undo</mat-icon>
                                        Revoke
                                    </button>
                                </mat-menu>
                                }
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="labRequestDisplayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: labRequestDisplayedColumns;"></tr>
                    </table>
                    } @else {
                    <div class="subtitle-text-color-2 mb-10">
                        @if(!labTestsActivated){
                        Open this section to load lab requests.
                        } @else {
                        No lab requests for this encounter.
                        }
                    </div>
                    }
                </div>

                <mat-action-row>
                    @if(canAddLabRequest){
                    <button mat-button class="lab-order-btn" (click)="orderAnotherLabTest()">
                        <mat-icon>add</mat-icon>
                        Order Another Lab Test
                    </button>
                    }
                </mat-action-row>

                <!-- <div class="g-just-flex gap-30 flex-wrap justify-content-start">
                    @for(eachlab of
                    labRequestAndValue;
                    track $index;){ <div class=" field-group" style="border-left: 2px solid var(--mat-sys-primary);
                    padding: 1px 12px; border-top-right-radius: 4px;
                     border-top-left-radius: 4px;
                    background-color: var(--mat-sys-surface-container-low);
                    flex: 0 1 max-content">
                        <div class="field-value">
                            {{eachlab.value}}
                        </div>
                        <div class="field-title subtitle-text-color-2">
                            {{eachlab.name}}
                        </div>
                    </div>
                    }
                    <div class="g-just-flex gap-30 flex-wrap justify-content-start">

                        <button mat-flat-button color="primary" (click)="requestLabTest()" style="border-left: 2px solid var(--mat-sys-primary);
                    padding: 4px 12px; border-radius: 4px;
                     
                    background-color: var(--mat-sys-on-surface);
                    color: var( --mat-sys-surface-container-low);
                    flex: 0 1 max-content">
                            <mat-icon>add</mat-icon>
                            Request Another Lab Test</button>
                    </div>
                </div> -->
                <!--Add a Lab test request button-->

            </mat-expansion-panel>
            }

            <mat-expansion-panel (opened)="onOtherServiceRequestsPanelOpened()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Service Requests
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="complaints-table-wrapper mb-16">
                    @if(otherServiceRequestsActivated){
                    @if((otherServiceRequestsLoading$ | async) === true && (!otherServiceRequestRows ||
                    otherServiceRequestRows.length === 0)){
                    <div class="subtitle-text-color-2 mb-10">Loading…</div>
                    }
                    }

                    @if(otherServiceRequestsActivated && otherServiceRequestRows && otherServiceRequestRows.length > 0){
                    <table mat-table [dataSource]="otherServiceRequestTableDataSource"
                        class="mat-elevation-z1 w-100 lab-tests-table">

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let r">
                                <div [appChips]="r.status" [fontSize]="'14px'"> </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="code">
                            <th mat-header-cell *matHeaderCellDef> Service </th>
                            <td mat-cell *matCellDef="let r" class="lab-code-cell">{{ r.code }}</td>
                        </ng-container>

                        <ng-container matColumnDef="request">
                            <th mat-header-cell *matHeaderCellDef> Requested </th>
                            <td mat-cell *matCellDef="let r">
                                @if(r.authoredOn){
                                <div class="lab-date-top">{{ r.authoredOn | date:'mediumDate' }}</div>
                                <div class="lab-date-bottom">{{ r.authoredOn | date:'shortTime' }}</div>
                                } @else {
                                <div class="subtitle-text-color-2">—</div>
                                }
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="report">
                            <th mat-header-cell *matHeaderCellDef> Evidence </th>
                            <td mat-cell *matCellDef="let r">
                                <div class="lab-report-action">
                                    <button mat-button class="lab-report-btn"
                                        (click)="viewServiceRequestEvidence(r)" [disabled]="!r.id">
                                        <mat-icon>{{ r.serviceRequestType === 'observation' ? 'biotech' : (r.serviceRequestType === 'procedure' || r.serviceRequestType === 'surgery' ? 'healing' : 'description') }}</mat-icon>
                                        {{ r.evidenceActionLabel || 'Report' }}
                                    </button>

                                    <span [appEmphasis]="r.reportAvailabilityStatus" [showBorder]="false"
                                        [fontSize]="'12px'" [opacity]="'0.85'" [title]="r.missingEvidenceText || ''">
                                        {{ labReportAvailabilityLabel(r.reportAvailabilityStatus) }}
                                    </span>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef> Action </th>
                            <td mat-cell *matCellDef="let r">
                                @if(canEditEncounter && !isPatientUser){
                                <button mat-button (click)="revokeServiceRequest(r)"
                                    [disabled]="!canEditEncounter || !r.id || !canRevokeServiceRequest(r)">
                                    <mat-icon>undo</mat-icon>
                                    Revoke
                                </button>
                                }
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="otherServiceRequestDisplayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: otherServiceRequestDisplayedColumns;"></tr>
                    </table>
                    } @else {
                    <div class="subtitle-text-color-2 mb-10">
                        @if(!otherServiceRequestsActivated){
                        Open this section to load service requests.
                        } @else {
                        No service requests for this encounter.
                        }
                    </div>
                    }
                </div>

                <mat-action-row>
                    @if(canEditEncounter && !isPatientUser && !isRestrictedClinicalRole){
                    <button mat-button class="lab-order-btn" (click)="requestAnotherService()">
                        <mat-icon>add</mat-icon>
                        Request Another Service
                    </button>
                    }
                </mat-action-row>
            </mat-expansion-panel>
            <!--Diagnosis Panel-->
            <mat-expansion-panel (opened)="onDiagnosisPanelOpened()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Diagnosis
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="diagnosis-table-wrapper mb-16">
                    @if(diagnosisActivated){
                    @if((diagnosisLoading$ | async) === true && (!diagnosisRows || diagnosisRows.length === 0)){
                    <div class="subtitle-text-color-2 mb-10">Loading…</div>
                    }
                    }

                    @if(diagnosisActivated && diagnosisRows && diagnosisRows.length > 0){
                    <table mat-table [dataSource]="diagnosisTableDataSource"
                        class="mat-elevation-z1 w-100 diagnosis-table">

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let d">
                                <div [appChips]="d.status" [fontSize]="'14px'"></div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="verificationStatus">
                            <th mat-header-cell *matHeaderCellDef> Verification </th>
                            <td mat-cell *matCellDef="let d">
                                <div [appChips]="d.verificationStatus" [fontSize]="'14px'"></div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="diagnosis">
                            <th mat-header-cell *matHeaderCellDef> Diagnosis </th>
                            <td mat-cell *matCellDef="let d" class="diagnosis-text-cell">{{ d.diagnosis }}</td>
                        </ng-container>

                        <ng-container matColumnDef="severity">
                            <th mat-header-cell *matHeaderCellDef> Severity </th>
                            <td mat-cell *matCellDef="let d">
                                @if(d.severity){
                                <span [appEmphasis]="d.severity" [fontSize]="'13px'">{{ d.severity }}</span>
                                } @else {
                                —
                                }
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="recorded">
                            <th mat-header-cell *matHeaderCellDef> Recorded </th>
                            <td mat-cell *matCellDef="let d">
                                @if(d.recordedDate){
                                <div class="lab-date-top">{{ d.recordedDate | date:'mediumDate' }}</div>
                                <div class="lab-date-bottom">{{ d.recordedDate | date:'shortTime' }}</div>
                                } @else {
                                <div class="subtitle-text-color-2">—</div>
                                }
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef> Action </th>
                            <td mat-cell *matCellDef="let d">
                                @if(canEditEncounter){
                                <button mat-icon-button [matMenuTriggerFor]="diagMenu"
                                    (click)="$event.stopPropagation()">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #diagMenu="matMenu">
                                    <button mat-menu-item
                                        (click)="openChangeDiagnosisStatus(d); $event.stopPropagation()">
                                        <mat-icon>published_with_changes</mat-icon>
                                        Change Status
                                    </button>
                                </mat-menu>
                                }
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="diagnosisDisplayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: diagnosisDisplayedColumns;"></tr>
                    </table>
                    } @else {
                    <div class="subtitle-text-color-2 mb-10">
                        @if(!diagnosisActivated){
                        Open this section to load diagnosis.
                        } @else {
                        No diagnosis recorded for this encounter.
                        }
                    </div>
                    }
                </div>

                <mat-action-row>
                    @if(canEditEncounter && !isPatientUser){
                    <button mat-button (click)="encounterService.addDiagnosisV2()">
                        <mat-icon>add</mat-icon>
                        Add Diagnosis
                    </button>
                    }
                </mat-action-row>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Treatment Plan
                    </mat-panel-title>
                </mat-expansion-panel-header>

                @if(!isMedicationRestrictedRole){
                <mat-expansion-panel (opened)="onMedicationsPanelOpened()">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Medications
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    @if(medicationsActivated){
                    @if((medicationsLoading$ | async) === true && (!medRequestAndValue || medRequestAndValue.length ===
                    0)){
                    <div class="subtitle-text-color-2 mb-10">Loading…</div>
                    }
                    }

                    @if(medRequestAndValue && medRequestAndValue.length > 0) {
                    <div class="g-just-flex flex-wrap gap-30 " style="align-items: unset; gap:50px;">

                        @for(eachMed of medRequestAndValue; track $index;){
                        <div class="each-medicine p-12 g-just-flex gap-10 justify-content-start"
                            style="border-radius: 8px; min-height: 80px; position: relative;">
                            <!-- <div class="rounded-icon-wrapper">
                                <span class="material-symbols-outlined">
                                    pill
                                </span>
                            </div> -->
                            <div class="med-details g-just-flex gap-0 flex-column ">
                                <div class="rounded-icon-wrapper"
                                    style="position: absolute; right: calc(50% - 15px); top: -15px;">
                                    <span class="material-symbols-outlined">
                                        pill
                                    </span>
                                </div>
                                <div class="med-name" style="font-weight: 500; font-size: 16px;
                                max-width: 250px;
                                ">
                                    <!-- {{eachMed.original | json}} -->
                                    @if(eachMed.original?.medicationCodeableConcept){
                                    {{eachMed.original?.medicationCodeableConcept | codeableConcept2}}
                                    }@else if(eachMed.original?.medicationReference){
                                    <div [appReferenceDisplay]="eachMed.original?.medicationReference.reference"
                                        [InstantfetchAndRepace]="true">

                                    </div>
                                    }@else{
                                    N / A
                                    }
                                </div>
                                <mat-divider style="width: 100%;"></mat-divider>
                                <div class="dose-inst g-just-flex gap-8 pt-14 flex-wrap">
                                    <!-- @if(eachMed.dosage[0].route){
                                    <div class="med-route inst-unit">
                                        <span class="material-symbols-outlined">
                                            arrow_forward
                                        </span>
                                        <span class="med-route-amount">
                                            {{eachMed.dosage[0].route | codeableConcept2}}
                                        </span>
                                    </div>
                                    } -->
                                    @if(eachMed.dosage?.[0]?.doseAndRate?.[0]?.doseQuantity?.value){
                                    <div class="med-dose inst-unit">
                                        <span class="material-symbols-outlined">
                                            grain
                                        </span>
                                        <span class="med-dose-amount">
                                            {{eachMed.dosage?.[0]?.doseAndRate?.[0]?.doseQuantity?.value+"
                                            "+eachMed.dosage?.[0]?.doseAndRate?.[0]?.doseQuantity?.unit ||
                                            eachMed.dosage?.[0]?.doseAndRate?.[0]?.doseQuantity?.code}}
                                        </span>
                                    </div>
                                    } @else if (eachMed.value) {
                                    <div class="med-dose inst-unit">
                                        <span class="material-symbols-outlined">
                                            description
                                        </span>
                                        <span class="med-dose-amount">
                                            {{eachMed.value}}
                                        </span>
                                    </div>
                                    }

                                    @if(eachMed.timing){
                                    <div class="med-dose inst-unit">
                                        <span class="material-symbols-outlined">
                                            timer
                                        </span>
                                        <span class="med-dose-amount">
                                            {{eachMed.timing}}
                                        </span>
                                    </div>
                                    }

                                </div>


                            </div>


                        </div>
                        }

                    </div>
                    } @else {
                    <div class="subtitle-text-color-2 mb-10">
                        @if(!medicationsActivated){
                        Open this section to load medications.
                        } @else {
                        No medications for this encounter.
                        }
                    </div>
                    }

                    <mat-action-row>
                        @if(canEditEncounter && !isPatientUser){
                        <button mat-button (click)="addMedicationRequest()">
                            <mat-icon>add</mat-icon>
                            Add Medication
                        </button>
                        }
                    </mat-action-row>
                </mat-expansion-panel>
                }
            </mat-expansion-panel>
                
            <mat-expansion-panel (opened)="onPastDiagnosisPanelOpened()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Past Diagnosis (Summary)
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="diagnosis-table-wrapper mb-16">
                    @if(pastDiagnosisActivated){
                    @if((pastDiagnosisLoading$ | async) === true && (!pastDiagnosisRows || pastDiagnosisRows.length ===
                    0)){
                    <div class="subtitle-text-color-2 mb-10">Loading…</div>
                    }
                    }

                    @if(pastDiagnosisActivated && pastDiagnosisRows && pastDiagnosisRows.length > 0){
                    <table mat-table [dataSource]="pastDiagnosisTableDataSource"
                        class="mat-elevation-z1 w-100 diagnosis-table">

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let d">
                                <div [appChips]="d.status" [fontSize]="'14px'"></div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="verificationStatus">
                            <th mat-header-cell *matHeaderCellDef> Verification </th>
                            <td mat-cell *matCellDef="let d">
                                <div [appChips]="d.verificationStatus" [fontSize]="'14px'"></div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="diagnosis">
                            <th mat-header-cell *matHeaderCellDef> Diagnosis </th>
                            <td mat-cell *matCellDef="let d" class="diagnosis-text-cell">{{ d.diagnosis }}</td>
                        </ng-container>

                        <ng-container matColumnDef="recorded">
                            <th mat-header-cell *matHeaderCellDef> Recorded </th>
                            <td mat-cell *matCellDef="let d">
                                @if(d.recordedDate){
                                <div class="lab-date-top">{{ d.recordedDate | date:'mediumDate' }}</div>
                                <div class="lab-date-bottom">{{ d.recordedDate | date:'shortTime' }}</div>
                                } @else {
                                <div class="subtitle-text-color-2">—</div>
                                }
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="['status', 'verificationStatus', 'diagnosis', 'recorded']">
                        </tr>
                        <tr mat-row
                            *matRowDef="let row; columns: ['status', 'verificationStatus', 'diagnosis', 'recorded'];">
                        </tr>
                    </table>
                    } @else {
                    <div class="subtitle-text-color-2 mb-10">
                        @if(!pastDiagnosisActivated){
                        Open this section to load history.
                        } @else {
                        No historical diagnosis records.
                        }
                    </div>
                    }
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel (opened)="onPastVaccinationsPanelOpened()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Vaccinations (History)
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="diagnosis-table-wrapper mb-16">
                    @if(pastVaccinationsActivated){
                    @if((pastVaccinationsLoading$ | async) === true && (!immunizationRows || immunizationRows.length ===
                    0)){
                    <div class="subtitle-text-color-2 mb-10">Loading…</div>
                    }
                    }

                    @if(pastVaccinationsActivated && immunizationRows && immunizationRows.length > 0){
                    <table mat-table [dataSource]="immunizationTableDataSource"
                        class="mat-elevation-z1 w-100 diagnosis-table">

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let imm">
                                <div [appChips]="imm.status" [fontSize]="'14px'"></div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="vaccine">
                            <th mat-header-cell *matHeaderCellDef> Vaccine </th>
                            <td mat-cell *matCellDef="let imm" class="diagnosis-text-cell">{{ imm.vaccine }}</td>
                        </ng-container>

                        <ng-container matColumnDef="occurrence">
                            <th mat-header-cell *matHeaderCellDef> Date </th>
                            <td mat-cell *matCellDef="let imm">
                                @if(imm.occurrence){
                                <div class="lab-date-top">{{ imm.occurrence | date:'mediumDate' }}</div>
                                <div class="lab-date-bottom">{{ imm.occurrence | date:'shortTime' }}</div>
                                } @else {
                                <div class="subtitle-text-color-2">—</div>
                                }
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="['status', 'vaccine', 'occurrence']"></tr>
                        <tr mat-row *matRowDef="let row; columns: ['status', 'vaccine', 'occurrence'];"></tr>
                    </table>
                    } @else {
                    <div class="subtitle-text-color-2 mb-10">
                        @if(!pastVaccinationsActivated){
                        Open this section to load history.
                        } @else {
                        No historical vaccination records.
                        }
                    </div>
                    }
                </div>
            </mat-expansion-panel>
        </mat-card-content>

        <mat-card-actions [align]="'end'">
            <button class="py-10" mat-flat-button>Save Encounter Details</button>
        </mat-card-actions>
    </mat-card>
    } @else {
    <mat-card>
        <mat-card-header>
            <mat-card-title>Unauthorized Access</mat-card-title>
        </mat-card-header>
        <mat-card-content class="mt-18" style="padding: 40px 20px; text-align: center;">
            <p style="font-size: 1.2rem; color: #666;">You are not authorized to view this encounter's details.</p>
        </mat-card-content>
    </mat-card>
    }
</div>
